<template>
  <div
    :class="['addToBasket', { 'addToBasket--small': small, 'addToBasket--error': missingQuantity }]"
  >
    <div class="addToBasket__valuesWrapper">
      <div class="addToBasket__values">
        <span v-if="missingQuantity" class="addToBasket__available">
          <span class="addToBasket__availableIcon icon-check-border" />{{
            quantity - missingQuantity
          }}
        </span>
        <span v-if="missingQuantity" class="addToBasket__missing">
          <span class="addToBasket__availableIcon icon-wrong" />{{ missingQuantity }}
        </span>
      </div>
    </div>
    <span v-if="dateDeliveryInsufficientStock" class="addToBasket__availableDate"
      >dostępny od {{ dateDeliveryInsufficientStock }}</span
    >
    <div class="addToBasket__amount" v-if="value > 0 || value === '' || disableShowDefaultButton">
      <v-button
        text="-"
        theme="purple"
        :is-small-basket-button="!small"
        :is-small-dropdown-button="small"
        @click="minus"
      />
      <div class="addToBasket__count">
        <div class="addToBasket__countInner">
          <input
            type="number"
            :value="value"
            placeholder="0"
            class="addToBasket__input"
            @input="onInput"
            @keyup.enter="onEnter"
          />
          <span
            ref="countText"
            class="addToBasket__countText"
            :class="{ 'formCountInput__countText--empty': value === '' }"
            style="opacity: 0"
          >
            {{ inputText ? inputText : uom }}
          </span>
        </div>

        <div class="addToBasket__countInfo">
          <span class="addToBasket__countNumber">
            {{ value }}
          </span>
          <span
            ref="countText"
            class="addToBasket__countText"
            :class="{ 'formCountInput__countText--empty': value === '' }"
          >
            {{ inputText ? inputText : uom }}
          </span>
        </div>
      </div>
      <v-button
        text="+"
        theme="purple"
        :is-small-basket-button="!small"
        :is-small-dropdown-button="small"
        @click="plus"
      />
    </div>
    <v-button
      v-else
      :text="editOrderId ? 'Dodaj do zamówienia' : $t('addToCart')"
      theme="purple"
      full-width
      small-height
      :is-loading="isLoading"
      :disabled="disabled"
      @click="$emit('addToBasket')"
    />
  </div>
</template>

<script>
import VButton from '~/components/VButton';
import cartMixin from '~/mixins/cart';

export default {
  name: 'AddToBasket',
  components: {
    VButton,
  },
  mixins: [cartMixin],
  props: {
    disableShowDefaultButton: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    uom: {
      type: String,
      default: 'szt.',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    missingQuantity: {
      type: Number,
      default: null,
    },
    dateDeliveryInsufficientStock: {
      type: String,
      default: '',
    },
    inputText: {
      type: String,
      default: '',
    },
  },
  methods: {
    onEnter() {
      this.$emit('enter');
    },
    onInput(e) {
      if (e.target.value === '') this.$emit('input', '');
      else this.$emit('input', parseInt(e.target.value));
      this.$forceUpdate();
    },
    plus() {
      this.$emit('change', this.value + 1);
    },
    minus() {
      if (this.value >= 1) {
        this.$emit('change', this.value - 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.addToBasket {
  $root: &;
  width: 100%;
  min-width: 15rem;
  position: relative;

  @include rwd('large-phone') {
    min-width: 12.5rem;
  }

  &__amount {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid $cAddLight;
    border-radius: 3px;
    height: 5rem;
    padding: 5px;
  }

  &__count {
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
  }

  &__countInner {
    display: flex;
  }

  &__input {
    width: 100%;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 600;
    overflow: hidden;
    text-align: center;

    &::placeholder {
      color: $cMainDark;
      font-weight: 600;
    }

    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }

  &__countInfo {
    pointer-events: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &__countNumber {
    opacity: 0;
  }

  &__countText {
    &--empty {
      padding-left: 1.1rem;
    }
  }

  &__availableDate {
    pointer-events: none;
    position: absolute;
    bottom: -25px;
    left: 0;
  }

  &__available,
  &__missing {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 700;
    padding: 0 0.8rem;
  }

  &__available {
    top: -1px;
    color: $cBadgeBest;
  }

  &__missing {
    bottom: -1px;
    color: $cBadgeProm;
    border-left: 1px solid $cAddLight;
  }

  &__availableIcon {
    font-size: 1.6rem;
    padding-right: 4px;
  }

  &__valuesWrapper {
    pointer-events: none;
    position: absolute;
    left: 0;
    width: 100%;
    top: -2.4rem;
  }

  &__values {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &--error {
    #{$root}__amount {
      border: 1px solid $cSec;
      background: rgba($cSec, 0.1);
    }
  }

  &--small {
    min-width: 12.5rem;

    #{$root}__amount {
      height: 3.2rem;
    }

    #{$root}__input,
    #{$root}__count {
      font-size: 1.2rem;
    }
  }
}
</style>
